import { LitElement, html, css, nothing } from 'lit';
import { customElement, property } from 'lit/decorators.js';
import { tokens } from '../styles/tokens';
import { shared } from '../styles/shared';
import { STRINGS } from '../data/strings';

/**
 * Bouton rose "Étape suivante" — émet un CustomEvent `action` au clic.
 *
 * Le wrapping `.button-container` reproduit la gouttière à 62px du layout
 * d'origine sur ≥720px (cf. shared.ts) : le composant racine peut placer
 * `<sarah-bouton>` directement, sans avoir à se soucier de cet alignement.
 */
@customElement('sarah-bouton')
export class SarahBouton extends LitElement {
  static styles = [
    tokens,
    shared,
    css`
      :host { display: block; }

      .spinner-inline {
        display: inline-block;
        width: 14px;
        height: 14px;
        border: 2px solid currentColor;
        border-right-color: transparent;
        border-radius: 50%;
        animation: spin 0.6s linear infinite;
        margin-right: 8px;
      }
      @keyframes spin { to { transform: rotate(360deg); } }
    `,
  ];

  @property({ type: String }) label: string = STRINGS.btnNext;

  @property({ type: Boolean }) disabled = false;

  @property({ type: Boolean }) loading = false;

  private onClick(): void {
    if (this.disabled || this.loading) return;
    this.dispatchEvent(
      new CustomEvent('action', {
        detail: true,
        bubbles: true,
        composed: true,
      }),
    );
  }

  render() {
    return html`
      <div class="button-container">
        <button
          class="btn"
          type="button"
          ?disabled=${this.disabled || this.loading}
          aria-busy=${this.loading}
          @click=${this.onClick}
        >
          ${this.loading
            ? html`<span class="spinner-inline" aria-hidden="true"></span>`
            : nothing}
          ${this.label}
        </button>
      </div>
    `;
  }
}

declare global {
  interface HTMLElementTagNameMap {
    'sarah-bouton': SarahBouton;
  }
}
